import styled from "styled-components";
import theme from "../../style/theme";
import LockLineIcon from "../icons/LockLineIcon";

interface Props {
  placeholder: string;
  name?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  width: string;
  isError?: boolean;
}

export const LockTextField: React.FC<Props> = ({
  placeholder,
  name,
  value,
  onChange,
  width,
  isError,
}) => {
  const resetPlaceholder =
    () => (event: React.FocusEvent<HTMLInputElement>) => {
      event.target.placeholder = placeholder;
    };

  const isValue = Boolean(value);

  return (
    <TextFieldContainer width={width}>
      <TextField
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={resetPlaceholder}
        isError={isError}
        isValue={isValue}
      />
      {!isValue && (
        <LeftIconWarpper>
          <LockLineIcon />
        </LeftIconWarpper>
      )}
    </TextFieldContainer>
  );
};

interface TextFieldContainerProps {
  width: string;
}

const TextFieldContainer = styled.div<TextFieldContainerProps>`
  position: relative;
  width: ${(props) => props.width}};
`;

interface TextFieldProps {
  isError?: boolean;
  isValue?: boolean;
}

const TextField = styled.input<TextFieldProps>`
  width: 100%;
  height: 2.625rem;
  padding: 0 0 0 ${(props) => (props.isValue ? "11px" : "35px")}};
  border: 1px solid
    ${(props) => {
      if (props.isError) {
        return theme.palette.primitives.red500;
      }
      if (props.isValue) {
        return theme.palette.primitives.gray300;
      }
      return theme.palette.primitives.gray200;
    }};
  border-radius: 4px;
  background: ${(props) =>
    props.isValue ? "#ffffff" : theme.palette.primitives.gray50};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${theme.palette.primitives.black};
  box-sizing: border-box;
  outline: none;
  &::placeholder {
    color: ${theme.palette.primitives.gray300};
  }
  &:focus {
    border: 1px solid #fcca00;
  }
`;

const LeftIconWarpper = styled.div`
  position: absolute;
  width: 1.125rem;
  height: 1.125rem;
  box-sizing: border-box;
  top: 50%;
  transform: translateY(-50%);
  left: 11px;
`;
